import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

const getFinancesModalFormSchema = (t: TranslateFunction) =>
	z.object({
		name: z.string({
			required_error: t(Resources.Form.Validations.required),
		}),
		amount: z.number({
			required_error: t(Resources.Form.Validations.required),
		}),
	});

export type FinancesModalFormModel = z.infer<
	ReturnType<typeof getFinancesModalFormSchema>
>;

export type FinancesModalInitialValues = {
	name: string;
	amount: number;
};

type UseFinancesModalFormProps = {
	initialValues?: FinancesModalInitialValues;
};

export const useFinancesModalForm = ({
	initialValues,
}: UseFinancesModalFormProps) => {
	const { t } = useResource();

	const form = useForm<FinancesModalFormModel>({
		resolver: zodResolver(getFinancesModalFormSchema(t)),
		defaultValues: initialValues
			? {
					name: initialValues.name,
					amount: initialValues.amount,
				}
			: undefined,
	});

	return form;
};
